<template>
    <page-container2 :title="formTitle" useCard>
        <template v-slot:buttons>
            <el-button type="primary" size="mini" @click="save">保存</el-button>
        </template>
        <permission-container :permissionId="permissionId" showTip>
            <el-form ref="userForm" :model="userForm" v-loading="loading" status-icon :rules="rules" label-width="100px">
                <el-form-item label="登录账号" prop="username">
                    <el-input v-model="userForm.username" autocomplete="off" class="one-third-width" ></el-input>
                </el-form-item>
                <el-form-item label="昵称" prop="nickname">
                    <el-input v-model="userForm.nickname" autocomplete="off" class="one-third-width" ></el-input>
                </el-form-item>
                <el-form-item label="用户类型" prop="type">
                    <el-radio v-model="userForm.type" label="1">管理员</el-radio>
                    <el-radio v-model="userForm.type" label="2">普通用户</el-radio>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="userForm.password" autocomplete="new-password" class="one-third-width"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPassword">
                    <el-input type="password" v-model="userForm.checkPassword" autocomplete="new-password" class="one-third-width"></el-input>
                </el-form-item>
                   <el-form-item label="是否禁用" prop="disabled">
                       <el-radio v-model="userForm.state" label="1">可用</el-radio>
                       <el-radio v-model="userForm.state" label="9">禁用</el-radio>
                   </el-form-item>
                   <el-form-item label="角色" prop="roleList">
                       <el-select v-model="userForm.roleList" multiple size="medium" placeholder="请选择" class="one-third-width">
                           <el-option
                               v-for="item in roleList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                           </el-option>
                       </el-select>
                   </el-form-item>
            </el-form>
        </permission-container>
    </page-container2>
</template>

<script>
import List from "@/components/table/List";
import md5 from 'js-md5';
export default {
    name: "UserEdit",
    data()
    {
        let checkPassword = (rule, value, callback)=>
        {
            if(!this.userForm.id || value)
            {
                if(!value)
                {
                    callback(new Error('请输入密码'));
                }
                else if(value.length < 6 || value.length > 16)
                {
                    callback(new Error('请输入6-12位密码'));
                }
                callback();
            }
            else
            {
                callback();
            }
        };
        let validateCheckPassword = (rule, value, callback) => {
            if (value !== this.userForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            userForm: {
                id: 0,
                username: '',
                nickname: '',
                password: '',
                checkPassword: '',
                type: '2',
                state: '1',
                roleList: [],
            },
            rules: {
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                ],
                password: [
                    // { required: true, message: '请输入密码', trigger: 'blur' },
                    { validator: checkPassword, trigger: 'blur' }
                ],
                checkPassword: [
                    // { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: validateCheckPassword, trigger: 'blur' }
                ]
            },
            roleList: [],
            loading: false,
            permissionId: "System.User.Add",
            formTitle: "添加用户"
        };
    },
    mounted()
    {
        // console.log('user edit mounted.', this.$route.query);
        return Fx.Promise.then(()=>
        {
            if(this.$route.query && this.$route.query.id)
            {
                this.permissionId = "System.User.Edit";
                this.formTitle = "编辑用户";
                return Fx.Http.post("/system/user/get", {id: this.$route.query.id}).
                then((response)=>
                {
                    console.log(response);
                    if(response.isSuccess())
                    {
                        this.userForm.id = response.getData("id");
                        this.userForm.username = response.getData("username");
                        this.userForm.nickname = response.getData("nickname");
                        this.userForm.type = ""+response.getData('type');
                        this.userForm.state = ""+response.getData('state');
                        this.userForm.roleList = (response.getData('roleList')||[]).map(r => r.roleId);
                        this.userForm.password = '';
                        this.userForm.checkPassword = '';
                    }
                });
            }
        }).
        then(() =>
        {
            return Fx.Http.post("/system/role/listAll").
            then((res)=>
            {
                if(res.isSuccess())
                {
                    this.roleList = res.getData('roleList');
                }
            })
        });

    },
    methods: {
        save()
        {
            console.log(this.userForm);
            this.$refs.userForm.validate(valid =>
            {
                if(!valid) return;
                this.loading = true;
                let savePath = "/system/user/add";
                if(this.userForm.id)
                {
                    savePath = "/system/user/edit";
                }
                let data = this.userForm;
                if(this.userForm.password) {
                    data.password = md5(this.userForm.password);
                    data.checkPassword = md5(this.userForm.checkPassword);
                }
                return Fx.Http.post(savePath, data).
                then((resp)=>
                {
                    this.loading = false;
                    if(resp.isSuccess() && resp.getData("id"))
                    {
                        this.showMessageSuccess('保存成功',()=>
                        {
                            this.dispatchRouteBack();
                        });
                    }
                    else
                    {
                        this.showMessageError(resp.getErrorMessage());
                    }
                });
            });
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/system/pages/user/Edit.vue